"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.whatsapp.group': 'WhatsApp Group',
    'route.whatsapp.group.create': 'Add WhatsApp Group',
    'route.whatsapp.dm': 'WhatsApp DM Contact',
};
